import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { Device, DeviceInfo } from '@capacitor/device';
import { AppUpdate } from '@capawesome/capacitor-app-update';

export type Platform = `android` | `ios` | `web`;

class CapacitorService {
  private _deviceInfo: DeviceInfo | undefined;
  private _appFullVersion: string | undefined;
  private _storeVersion: string | undefined; // Android works with the build version and IOS with the CFBundleShortVersionString
  private _buildVersion: string | undefined;
  private _appVersion: string | undefined;
  constructor() {
    // if (configuration.ENVIRONMENT === `DEVELOPMENT`) {
    //   Capacitor.DEBUG = true;
    // }

    this.getAppVersion();
  }

  private getAppVersion = async () => {
    if (this.isNative()) {
      const { name, version, build } = await CapacitorApp.getInfo();
      this._appFullVersion = `${name} v${build} (${version})`;
      this._storeVersion = await this.getAvailableStoreVersion();
      this._buildVersion = build;
      this._appVersion = version;
      this._deviceInfo = await Device.getInfo();
    }
  };

  // AppUpdate Capacitor Plugin -- https://capawesome.io/plugins/app-update/
  private getAvailableStoreVersion = async () => {
    const result = await AppUpdate.getAppUpdateInfo();
    if (this.isAndroid()) {
      return result.availableVersionCode; // This in theory should be like the build version
    }
    if (this.isIOS()) {
      return result.availableVersionName; // however, this should be the version ex: 1.0.0
    }
    return undefined;
  };

  hasDifferentVersion = () => {
    if (this.isAndroid()) {
      return this._storeVersion && this._buildVersion && this._storeVersion !== this._buildVersion;
    }
    if (this.isIOS()) {
      return this._storeVersion && this._appVersion && this._storeVersion !== this._appVersion;
    }
    return undefined;
  };

  openAppStore = () => {
    // If device is Android, open the Play Store
    if (this.isAndroid()) {
      window.location.href = `https://play.google.com/store/apps/details?id=com.routal.drivers`;
      return;
    }
    // If device is iOS, open the App Store
    if (this.isIOS()) {
      window.location.href = `https://apps.apple.com/es/app/routal/id6741764694`;
      return;
    }
    // await AppUpdate.openAppStore(); // ADD THIS IF SOME DEVICE DOESN'T OPEN THE STORE
  };

  isNative = () => {
    return Capacitor.isNativePlatform(); // true for Android/iOS, false for Web
  };

  getPlatform = () => {
    return Capacitor.getPlatform() as Platform;
  };

  isWeb = () => {
    return this.getPlatform() === `web`;
  };

  isIOS = () => {
    return this.getPlatform() === `ios`;
  };

  isAndroid = () => {
    return this.getPlatform() === `android`;
  };

  getApplicationVersion = () => {
    return this._appFullVersion;
  };

  getAppVersionV2 = () => {
    //TODO DELETE
    return this._appVersion;
  };

  getStoreVersion = () => {
    return this._storeVersion;
  };

  isEmulator = () => {
    return this._deviceInfo?.isVirtual ?? false;
  };
}

export const capacitorService = new CapacitorService();
